module.exports = __webpack_public_path__ + "static/media/File - Download.70cf71cd.svg";